
import { frodoBio, hollyBio, gatsbyBio } from './luigiBios'
import { frodoReviewerReviewHinge, hollyReviewerReviewBumble, gatsbyReviewerReviewTinder } from './luigiReviewerReviews'

export const frodoReviewerProfile = {
  _id: 'frodoReviewerProfileId',
  userId: 'frodoUserId',
  email: 'frodo@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-8-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...frodoBio },
  profileReviews: [
    // { ...frodoProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...frodoReviewerReviewHinge }
  ],
}

export const hollyReviewerProfile = {
  _id: 'hollyReviewerProfileId',
  userId: 'hollyUserId',
  email: 'holly@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-12-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...hollyBio },
  profileReviews: [
    // { ...hollyProfileReviewBumble }
  ],
  reviewerReviews: [
    { ...hollyReviewerReviewBumble }
  ],
}

export const gatsbyReviewerProfile = {
  _id: 'gatsbyReviewerProfileId',
  userId: 'gatsbyUserId',
  email: 'gatsby@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-gatsby-12-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...gatsbyBio },
  profileReviews: [
    // { ...gatsbyProfileReviewTinder }
  ],
  reviewerReviews: [
    { ...gatsbyReviewerReviewTinder }
  ],
}